import { Fragment, useState } from "react";
import { ChooseRequests } from "./ChooseRequests";
import CollectionForm from "./CollectionForm";

// CollectionForm now renders its own .mca-drawer (McaDrawer), so this wrapper no
// longer needs a Bootstrap Offcanvas — it just forwards `show` + the step-2
// (ChooseRequests) plumbing.
export const AddCollection = ({
  show,
  handleClose,
  activeCollection,
  activeModal,
  setActiveModal,
}) => {
  const [showRequests, setShowRequests] = useState(false);
  const [collectionId, setCollectionId] = useState(false);

  return (
    <Fragment>
      <CollectionForm
        show={show}
        handleClose={handleClose}
        setShowRequests={setShowRequests}
        setCollectionId={setCollectionId}
        activeCollection={activeCollection}
        activeModal={activeModal}
        setActiveModal={setActiveModal}
      />

      <ChooseRequests
        show={showRequests}
        handleClose={() => setShowRequests(false)}
        setShowRequests={setShowRequests}
        collectionId={collectionId?.id}
        requestType={collectionId?.request_type || "amazon"}
      />
    </Fragment>
  );
};
